import { call, all, takeLatest, put } from 'redux-saga/effects';
import createFetchFunction from '../utils/create-fetch-func';
import createFetchSagaPattern from '../fetch/fetch-saga-pattern-creator';
import getFetchInstance from './../utils/fetch';
import getDataFromResponse from '../utils/get-data-from-res';
import {
    fetchScore,
    IFetchScorePayload,
    IFetchScoresPayload,
    fetchScores,
    IInsertScorePayload,
} from './score.actions';

function* insertScoreAsync({
    payload: { data },
}: {
    payload: IInsertScorePayload;
}) {
    yield getFetchInstance().post('answercorrection/getScorePerStudent', data);
}

function* fetchScoreAsync({
    payload: { data },
}: {
    payload: IFetchScorePayload;
}) {
    const res = yield getFetchInstance().post(
        'answercorrection/nohistory',
        data
    );
    const score = getDataFromResponse(res).score;
    yield put(
        fetchScore({
            score,
        })
    );
}

function* fetchScoresAsync({
    payload: { data },
}: {
    payload: IFetchScoresPayload;
}) {
    const res = yield getFetchInstance().post('history/scorestudent', data);
    const scores = getDataFromResponse(res);
    yield put(
        fetchScores({
            scores,
        })
    );
}

function* watchInsertScore() {
    yield takeLatest(
        createFetchSagaPattern('INSERT_SCORE'),
        createFetchFunction('INSERT_SCORE', insertScoreAsync)
    );
}

function* watchFetchScore() {
    yield takeLatest(
        createFetchSagaPattern('SCORE'),
        createFetchFunction('SCORE', fetchScoreAsync)
    );
}

function* watchFetchScores() {
    yield takeLatest(
        createFetchSagaPattern('SCORES'),
        createFetchFunction('SCORES', fetchScoresAsync)
    );
}

export default function* scoreSagas() {
    yield all([
        call(watchInsertScore),
        call(watchFetchScore),
        call(watchFetchScores),
    ]);
}
